import getLocal from '@/app/utils/i18n';
import A from '../../comps/A';
import B from '../../comps/B';
// import C from '../../comps/C';
import C2 from '../../comps/C2';
import E from '../../comps/E';
import F from '../../comps/F';
import G from '../../comps/G';
import H from '../../comps/H';
import I from '../../comps/I';
import J from '../../comps/J';
import K from '../../comps/K';
import L from '../../comps/L';
import M from '../../comps/M';
// import N from '../../comps/N';
import O from '../../comps/O';
import P from '../../comps/P';
import FooterTcA from '../../comps/FooterTcA';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import dynamic from 'next/dynamic';
const N = dynamic(() => import('../../comps/N'));

const Overview: React.FC = () => {
    const { locale = 'us' } = getLocal();
    if (typeof window !== 'undefined') {
        if (!window?.AniContainer) {
            window.AniContainer = new EfScrollAni();
        }
    }

    return (
        <div className={`smart-gateway-overview ${css.page}`}>
            <A />
            <B />
            <C2 />
            {/* <C /> */}
            {/* {typeof window !== 'undefined' && window?.innerWidth < 1024 ? <E /> : <ListAni />} */}
            {/* <D /> */}
            <E />
            <F />
            <G />
            <H />
            <I />
            <div className="bg-white">
                <J />
                <K />
                <L />
                {locale !== 'ca' && <M />}
                {locale !== 'ca' && <N />}
                {locale !== 'ca' && <O />}
                <P />
            </div>
            <FooterTcA />
        </div>
    );
};

export default Overview;
